import React from "react";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ReferenceLine,
    ResponsiveContainer,
} from "recharts";
import { getColor } from "./chart-colors";
import { formatValue } from "./format-value";

const ChartLine = ({ spec, data, height = 300 }) => {
    const { xAxis, series = [], referenceLines = [], formatting } = spec;
    const valueType = formatting?.valueType;

    return (
        <ResponsiveContainer width="100%" height={height}>
            <LineChart data={data} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                <XAxis dataKey={xAxis?.key} tick={{ fontSize: 12 }} />
                <YAxis tick={{ fontSize: 12 }} tickFormatter={(v) => formatValue(v, valueType)} />
                <Tooltip formatter={(v, name) => [formatValue(v, valueType), name]} />
                <Legend />
                {referenceLines.map((rl) => (
                    <ReferenceLine
                        key={`${rl.y}-${rl.label || ""}`}
                        y={rl.y}
                        label={rl.label}
                        stroke={rl.color || "#999"}
                        strokeDasharray="4 4"
                    />
                ))}
                {series.map((s, i) => (
                    <Line
                        key={s.key}
                        type="monotone"
                        dataKey={s.key}
                        name={s.label}
                        stroke={s.color || getColor(i)}
                        dot={false}
                        strokeWidth={2}
                    />
                ))}
            </LineChart>
        </ResponsiveContainer>
    );
};

export default ChartLine;
